import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Redefinicao from "./Redefinicao";

const Index = ({ match }) => (
  <div className="content-wrapper">
    <Redefinicao />
    {/* <Switch>
            <Redirect exact from={`${match.url}/`} to={`${match.url}/redefinicao-senha`} />
            <Route path={`${match.url}/redefinicao-senha`} component={Redefinicao} />
        </Switch> */}
  </div>
);

export default Index;
